function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { ExpandedBonusTable, BonusTableRow, BonusTableHeader } from './bonusTable';
import Translate from '../../../components/Translate';

var TABLETYPES = {
  Bonus: 'bonus',
  History: 'history'
};

var ExpandedTable = function ExpandedTable(_ref) {
  var tableType = _ref.tableType,
      props = _objectWithoutProperties(_ref, ['tableType']);

  switch (tableType) {
    case TABLETYPES.Bonus:
      return React.createElement(ExpandedBonusTable, props);
    case TABLETYPES.History:
      // return history table here etc...
      return null;
    default:
      return null;
  }
};

export { ExpandedTable };
var TableRow = function TableRow(_ref2) {
  var tableType = _ref2.tableType,
      props = _objectWithoutProperties(_ref2, ['tableType']);

  switch (tableType) {
    case TABLETYPES.Bonus:
      return React.createElement(BonusTableRow, props);
    case TABLETYPES.History:
      return null;
    default:
      return null;
  }
};

export { TableRow };
export var TableRowNoData = function TableRowNoData(_ref3) {
  var tableType = _ref3.tableType;

  switch (tableType) {
    case TABLETYPES.Bonus:
      return React.createElement(
        'center',
        { className: 'no-data-message' },
        React.createElement(Translate, { defaultMessage: 'label.no_bonuses', id: 'label.no_bonuses' })
      );
    case TABLETYPES.History:
      return null;
    default:
      return null;
  }
};

export var TableHeader = function TableHeader(_ref4) {
  var tableType = _ref4.tableType;

  switch (tableType) {
    case TABLETYPES.Bonus:
      return React.createElement(BonusTableHeader, null);
    case TABLETYPES.History:
      return null;
    default:
      return null;
  }
};